import PropTypes from "prop-types";
import "./ToggleSwitch.scss";

const ToggleSwitch = ({
  value = false,
  onChange,
  isDisabled = false,
  stopPropagation = true
}) => {
  const handleToggle = (e) => {
    if (stopPropagation) {
      e.originalEvent?.stopPropagation();
    }
    if (isDisabled) return;
    onChange?.(e);
  };

  return (
    <label className={`toggle ${isDisabled ? "disabled" : ""}`}>
      <input
        type="checkbox"
        checked={value}
        onChange={handleToggle}
        disabled={isDisabled}
      />
      <span className="slider" />
    </label>
  );
};

ToggleSwitch.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  stopPropagation: PropTypes.bool
};

export default ToggleSwitch;